import React, { useState } from 'react';
import { Text, Button } from 'v3/components';
import { useFleetManagement } from '../../shared';
import { HeadingContainer, StyledModal } from './styles';
import TravelOutside from './TravelOutside';
import CreateNewOutsideTravel from '../CreateNewOutsideTravel';

const OutsideTravelModal = () => {
  const {
    outsideTravelModal: modalHook,
    setSelected,
    selected,
    isCreateOpen,
    setIsCreateOpen,
  } = useFleetManagement();

  const handleClose = () => {
    setSelected(null);
    setIsCreateOpen(false);
    modalHook.close();
  };

  return (
    <StyledModal
      show={modalHook.isOpen}
      size={isCreateOpen ? "lg" : "md"}
      body={isCreateOpen ? <CreateNewOutsideTravel /> : <TravelOutside />}
      heading={
        <HeadingContainer>
          {
            isCreateOpen ? (
              <Text>
                {`Inclusão de viagem externa para a placa ${selected?.plate?.plate}`}
              </Text>
            ) : (
              <Text type="header">Viagens externas</Text>
            )
          }
          {
            !isCreateOpen && (
              <Button onClick={() => setIsCreateOpen(!isCreateOpen)} variant="primary">
                Adicionar viagem externa
              </Button>
            )
          }
        </HeadingContainer>
      }
      handleClose={handleClose}
    />
  );
};

export default OutsideTravelModal;
